export var formatNumber = function (number) {
    var formatter = new Intl.NumberFormat('en-US');
    return formatter.format(number);
};
export function handleFocus(e) {
    return e.target.value = e.target.value == 0 || e.target.value == '0' ? '' : e.target.value;
}
